import {
  ChangeDetectorRef,
  InjectionToken,
  Pipe,
  PipeTransform,
  inject,
} from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

export const TRANSLATION_PREFIX = new InjectionToken('translation-prefix', {
  factory: () => 'main',
});

const hideMissingTranslations = true;
const COMMON_PREFIX = 'common';

@Pipe({
  name: 't',
  standalone: true,
  pure: false,
})
export class TPipe extends TranslatePipe implements PipeTransform {
  prefix = inject(TRANSLATION_PREFIX);

  constructor(
    private readonly translateService: TranslateService,
    _ref: ChangeDetectorRef
  ) {
    super(translateService, _ref);
  }

  override transform(
    value: string | null | undefined,
    ...args: unknown[]
  ): string {
    if (!value) {
      return '';
    }

    let suffix = '';
    if (args[0] && typeof args[0] === 'object' && 'count' in args[0]) {
      if ((args[0].count as number) === 0 || (args[0].count as number) > 1) {
        suffix = '_other';
      } else {
        suffix = '_one';
      }
    }
    
    const translationKey = `${this.prefix}.${value}${suffix}`;
    const translation = super.transform(translationKey, ...args);
    
    if (translation === translationKey) {
      const commonTranslationKey = `${COMMON_PREFIX}.${value}${suffix}`;
      const commonTranslation = super.transform(commonTranslationKey, ...args);
      
      if (hideMissingTranslations && commonTranslation === commonTranslationKey) {
        return value;
      }
      
      return commonTranslation;
    }

    return translation;
  }
}